// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"561fe7f5","453":"34ad63e0","455":"c730eb18","977":"d5994672"}[chunkId] + ".chunk.js";
};